import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
    // Aliments de base
    'Mukate (Pain)': {
        translation: 'Pain',
        translationEn: 'Bread',
        illustration: '🍞',
        audio: 'Li-mukate'
    },
    'Mampa (Pain – variante populaire)': {
        translation: 'Pain (variante populaire)',
        translationEn: 'Bread (popular variant)',
        illustration: '🍞',
        audio: 'Li-mampa'
    },
    'Nyama (Viande)': {
        translation: 'Viande',
        translationEn: 'Meat',
        illustration: '🥩',
        audio: 'Li-nyama'
    },
    'Mbisi (Poisson)': {
        translation: 'Poisson',
        translationEn: 'Fish',
        illustration: '🐟',
        audio: 'Li-mbisi'
    },
    'Ndunda (Légumes)': {
        translation: 'Légumes',
        translationEn: 'Vegetables',
        illustration: '🥬',
        audio: 'Li-ndunda'
    },
    'Mbuma (Fruit)': {
        translation: 'Fruit',
        translationEn: 'Fruit',
        illustration: '🍎',
        audio: 'Li-mbuma'
    },
    'Mayi (Eau)': {
        translation: 'Eau',
        translationEn: 'Water',
        illustration: '💧',
        audio: 'Li-mayi'
    },
    'Loso (Riz)': {
        translation: 'Riz',
        translationEn: 'Rice',
        illustration: '🍚',
        audio: 'Li-loso'
    },

    // Plats traditionnels
    'Saka saka (Feuilles de manioc pilées)': {
        translation: 'Feuilles de manioc pilées',
        translationEn: 'Pounded cassava leaves',
        illustration: '🥬',
        audio: 'Li-saka_saka'
    },
    'Fufu (Pâte de manioc / pâte épaisse)': {
        translation: 'Pâte de manioc / pâte épaisse',
        translationEn: 'Cassava paste / thick paste',
        illustration: '🥟',
        audio: 'Li-fufu'
    },
    'Pondu (Feuilles de manioc cuites / “pondu” / “pondu ya moto”)': {
        translation: 'Feuilles de manioc (cuites)',
        translationEn: 'Cassava leaves (cooked)',
        illustration: '🌿',
        audio: 'Li-pondu'
    },
    'Nsoso (Poulet / volaille)': {
        translation: 'Poulet / Volaille',
        translationEn: 'Chicken / Poultry',
        illustration: '🐔',
        audio: 'Li-nsoso'
    },
    'Ngombe (Bœuf / viande de vache)': {
        translation: 'Bœuf / viande de vache',
        translationEn: 'Beef / cow meat',
        illustration: '🐄',
        audio: 'Li-ngombe'
    },

    // Légumes et accompagnements
    'Matembele (Feuilles de patate douce, “greens”)': {
        translation: 'Feuilles de patate douce (greens)',
        translationEn: 'Sweet potato leaves (greens)',
        illustration: '🥬',
        audio: 'Li-matembele'
    },
    'Madesu (Haricots / beans)': {
        translation: 'Haricots / Beans',
        translationEn: 'Beans',
        illustration: '🫘',
        audio: 'Li-madesu'
    },
    'Makemba (Bananes plantains / plantains frits ou bouillis)': {
        translation: 'Bananes plantains / plantains frits ou bouillis',
        translationEn: 'Plantains / fried or boiled plantains',
        illustration: '🍌',
        audio: 'Li-makemba'
    },
    'Mbala (Ignames / yam)': {
        translation: 'Ignames / Yam',
        translationEn: 'Yams',
        illustration: '🍠',
        audio: 'Li-mbala'
    },

    // Fruits
    'Malala (Oranges)': {
        translation: 'Oranges',
        translationEn: 'Oranges',
        illustration: '🍊',
        audio: 'Li-malala'
    },
    'Manga (Mangue)': {
        translation: 'Mangue',
        translationEn: 'Mango',
        illustration: '🥭',
        audio: 'Li-manga'
    },
    'Papayi (Papaye)': {
        translation: 'Papaye',
        translationEn: 'Papaya',
        illustration: '🥭',
        audio: 'Li-papayi'
    },
    'Sapata (Banane / “banane douce”, mot suggéré)': {
        translation: 'Banane / Banane douce',
        translationEn: 'Banana / sweet banana',
        illustration: '🍌',
        audio: 'Li-sapata'
    },

    // Condiments & aromates
    'Pilipili (Piment / piment fort)': {
        translation: 'Piment / Piment fort',
        translationEn: 'Pepper / hot pepper',
        illustration: '🌶️',
        audio: 'Li-pilipili'
    },
    'Sukali (Sucre)': {
        translation: 'Sucre',
        translationEn: 'Sugar',
        illustration: '🧂',
        audio: 'Li-sukali'
    },
    'Mungwa (Sel)': {
        translation: 'Sel',
        translationEn: 'Salt',
        illustration: '🧂',
        audio: 'Li-mungwa'
    },

    // Concepts alimentaires généraux
    'Bilei (Nourriture / Aliment)': {
        translation: 'Nourriture / Aliment',
        translationEn: 'Food',
        illustration: '🍽️',
        audio: 'Li-bilei'
    },
    'Mafuta (Huile / graisse / huile de cuisson)': {
        translation: 'Huile / Graisse / Huile de cuisson',
        translationEn: 'Oil / fat / cooking oil',
        illustration: '🛢️',
        audio: 'Li-mafuta'
    },
    'Litungulu (Oignon / légumes d’arôme)': {
        translation: 'Oignon / légumes d’arôme',
        translationEn: 'Onion / aromatic vegetables',
        illustration: '🧅',
        audio: 'Li-litungulu'
    },
    'Mbila (Noix / noix de palme, usage local)': {
        translation: 'Noix / Noix de palme (dans sauces locales)',
        translationEn: 'Nuts / palm nuts (used in local sauces)',
        illustration: '🌰',
        audio: 'Li-mbila'
    },

    // Boisson non-alcoolisée
    'Juice (Jus de fruit) – mot emprunt / usage moderne': {
        translation: 'Jus de fruit',
        translationEn: 'Fruit juice',
        illustration: '🧃',
        audio: 'Li-juice'
    }
};

export default nourriture;
